export function isSmartphoneForEkyc(userAgent?: string): boolean {
  const source =
    userAgent ??
    (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  const value = source.toLowerCase();

  if (!value) return false;
  if (value.includes('ipad') || value.includes('tablet')) return false;
  if (value.includes('iphone') || value.includes('ipod')) return true;
  return value.includes('android') && value.includes('mobile');
}
